import { render, staticRenderFns } from "./Shoes.vue?vue&type=template&id=8fcea47c&"
import script from "./Shoes.vue?vue&type=script&lang=js&"
export * from "./Shoes.vue?vue&type=script&lang=js&"
import style0 from "./Shoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports